import { LoadedStatus } from "@kaggle/components";
import { Kaggle } from "@kaggle/sdk";
import { combineReducers } from "redux";
import { UserSecretsActionKey } from "../../../actions/ActionKeys";
import { UserSecretsAction } from "../../../actions/userSecrets";
type UserSecretMetadata = Kaggle.Sdk.UserSecrets.Models.UserSecretMetadata;
type UserSecretKernelAttachmentMetadata = Kaggle.Sdk.UserSecrets.Models.UserSecretKernelAttachmentMetadata;

export const gcpSecrets = (
  state: LoadedStatus<UserSecretMetadata[]> = {
    status: "not-started",
  },
  action: UserSecretsAction
): LoadedStatus<UserSecretMetadata[]> => {
  switch (action.type) {
    case UserSecretsActionKey.LOADING_GCP_USER_SECRETS:
      return { status: "loading" };
    case UserSecretsActionKey.SET_GCP_USER_SECRETS:
      return {
        status: "success",
        payload: action.payload.gcpUserSecrets,
      };
    default:
      return state;
  }
};

export const gcpSecretAttachment = (
  state: LoadedStatus<UserSecretKernelAttachmentMetadata | null> = {
    status: "not-started",
  },
  action: UserSecretsAction
): LoadedStatus<UserSecretKernelAttachmentMetadata | null> => {
  switch (action.type) {
    case UserSecretsActionKey.LOADING_GCP_USER_SECRET_KERNEL_ATTACHMENT:
      return { status: "loading" };
    case UserSecretsActionKey.SET_GCP_USER_SECRET_KERNEL_ATTACHMENT:
      return {
        status: "success",
        payload: action.payload.gcpSecretAttachment,
      };
    default:
      return state;
  }
};

export const customSecrets = (
  state: LoadedStatus<UserSecretMetadata[]> = {
    status: "not-started",
  },
  action: UserSecretsAction
): LoadedStatus<UserSecretMetadata[]> => {
  switch (action.type) {
    case UserSecretsActionKey.SET_CUSTOM_USER_SECRETS:
      return {
        status: "success",
        payload: action.payload.customUserSecrets,
      };
    case UserSecretsActionKey.UPDATE_CUSTOM_USER_SECRET:
      if (state.status === "success") {
        // Update the existing custom secret, or insert if it doesn't
        // exist, based on the secret id.
        const updatedSecrets = state.payload
          .filter(
            secret => secret.secretId !== action.payload.customSecret.secretId
          )
          .concat([action.payload.customSecret]);
        return {
          status: "success",
          payload: updatedSecrets,
        };
      }
      return state;
    default:
      return state;
  }
};

export const customSecretAttachments = (
  state: LoadedStatus<UserSecretKernelAttachmentMetadata[]> = {
    status: "not-started",
  },
  action: UserSecretsAction
): LoadedStatus<UserSecretKernelAttachmentMetadata[]> => {
  switch (action.type) {
    case UserSecretsActionKey.SET_CUSTOM_USER_SECRET_KERNEL_ATTACHMENTS:
      return {
        status: "success",
        payload: action.payload.customSecretAttachments,
      };
    case UserSecretsActionKey.ADD_CUSTOM_USER_SECRET_KERNEL_ATTACHMENT:
      // Now add it this new attachment to the state.
      // We always expect state to be loaded for this action but
      // use this as a typeguard.
      if (state.status === "success") {
        const attachedCustomSecrets = state.payload.concat([
          action.payload.customSecretAttachment,
        ]);
        return {
          status: "success",
          payload: attachedCustomSecrets,
        };
      }
      return state;
    case UserSecretsActionKey.REMOVE_CUSTOM_USER_SECRET_KERNEL_ATTACHMENT:
      // Now add it this new attachment to the state.
      // We always expect state to be loaded for this action but
      // use this as a typeguard.
      if (state.status === "success") {
        const attachedCustomSecrets = state.payload.filter(
          attachment =>
            attachment.attachmentId !== action.payload.customSecretAttachmentId
        );
        return {
          status: "success",
          payload: attachedCustomSecrets,
        };
      }
      return state;
    default:
      return state;
  }
};

/** Manages state of modals displayed on the UI. */
export const userSecrets = combineReducers({
  gcpSecrets,
  gcpSecretAttachment,
  customSecrets,
  customSecretAttachments,
});
